module.exports = __webpack_public_path__ + "img/block2.a15cad51.svg";